import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { EVENTS } from '@r1-frontend/shared/constants/analytics';
import { CATEGORIES } from '@r1-frontend/shared/constants/analytics';

import { ACTIONS } from '~/src/features/bundles/constants/analytics';

const sendClickChooseTariff = (tariffLine: string, isVillage: boolean): void => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.tariffCards,
        action: isVillage ? ACTIONS.openApplicationForm : ACTIONS.clickChooseTariff,
        label: `${tariffLine} | ${isVillage ? 'private sector' : 'flat'}`,
    });
};

export default sendClickChooseTariff;
